import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { AlertCircleIcon, ArrowLeftIcon } from 'lucide-react';
import { legalDocuments } from '../data/legal';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { Footer } from '../components/Footer';
export function LegalPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const {
    openSettings
  } = useCookieConsent();
  const doc = legalDocuments.find(item => item.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  return <div className="w-full bg-white font-sans text-ink" data-id="element-256" data-mp="2n6d0uzt3ps9x">
      <header className="border-b border-mint-100 bg-mint-50" data-id="element-257" data-mp="2n4tin3nvx75i">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-6 py-5" data-id="element-258" data-mp="2i7tdcuyv08fg">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-mint-700 transition-colors duration-150 ease-out hover:text-mint-800" data-id="element-259" data-mp="1brr38bxiunmx">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="16u7qjggh2ix3" />
            Volver al Megapack
          </Link>
          <span className="font-display text-lg text-mint-700" data-id="element-261" data-mp="1meatqtwlvq58">Naturia</span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-14 sm:py-20" data-id="element-262" data-mp="18ei5d58jxm0f">
        {doc ? <article data-id="element-263" data-mp="18gma1pe9yp1r">
            <h1 className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-264" data-mp="1ddl2m3iainxu">
              {doc.title}
            </h1>

            {doc.pendingNotice ? <p className="mt-6 flex items-start gap-3 rounded-2xl bg-mint-50 p-4 text-sm leading-relaxed text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-265" data-mp="ynx1b2a3zpa4">
                <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-700" aria-hidden="true" data-id="element-266" data-mp="poa8v5zcxtt7" />
                {doc.pendingNotice}
              </p> : null}

            <div className="mt-10 space-y-10" data-id="element-267" data-mp="tpvhgf4uzlxl">
              {doc.sections.map(section => <section key={section.heading} data-id="element-268" data-mp="fr5isv2e5e74">
                  <h2 className="font-display text-xl text-ink" data-id="element-269" data-mp="koxm0l8hkmqm">{section.heading}</h2>
                  <div className="mt-3 space-y-3" data-id="element-270" data-mp="kqryrc9lt8jm">
                    {section.paragraphs.map(paragraph => <p key={paragraph} className="text-[15px] leading-relaxed text-ink-soft" data-id="element-271" data-mp="2mg7kbrgzmjq3">
                        {paragraph}
                      </p>)}
                  </div>
                </section>)}
            </div>

            {doc.showCookieSettings ? <button type="button" onClick={openSettings} className="mt-10 inline-flex items-center justify-center rounded-full bg-mint-600 px-6 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-mint-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mint-700" data-id="element-272" data-mp="28nhm8oo6pocm">
                Configurar cookies
              </button> : null}
          </article> : <div data-id="element-273" data-mp="2rco8ums3n03p">
            <h1 className="font-display text-3xl text-ink" data-id="element-274" data-mp="2rcxwi3po8v68">Página no encontrada</h1>
            <p className="mt-4 text-ink-soft" data-id="element-275" data-mp="1kyowxb22ieqz">
              El documento que buscas no existe.{' '}
              <Link to="/" className="font-semibold text-mint-700 underline underline-offset-4" data-id="element-276" data-mp="1fwg4qgx0rgpx">
                Vuelve a la página principal
              </Link>
              .
            </p>
          </div>}
      </main>

      <Footer data-id="element-277" data-mp="1ar2qey0b9npc" />
    </div>;
}